export interface HitoTranslations {
  TABLE: {
      DESCRIPCION: string;
      FECHA_FIN: string;
      DIAS_RESTANTES: string;
      ACTIONS: string;

  };
  // Aquí puedes añadir más secciones de traducción según lo necesites

  // Esta línea es la clave para que el objeto sea indexable por TypeScript
  [key: string]: any;  // Usamos 'any' para simplificar, pero podrías ser más específico si quieres
}

export const hitoTranslations: { [language: string]: HitoTranslations } = {
    en: {
        TABLE: {
            DESCRIPCION: "Description",
            FECHA_FIN: "End date",
            DIAS_RESTANTES: "Days",
            ACTIONS: "Actions",
        },
    },
    es: {
        TABLE: {
            DESCRIPCION: "Descripción",
            FECHA_FIN: "Fecha fin",
            DIAS_RESTANTES: "Días",
            ACTIONS: "Acciones",

        },
    }
};

